// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { ApiKeyAuth, OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgeAuthenticationApi = class EdgeAuthenticationApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'ApiKey': new ApiKeyAuth('header', 'x-apikey'),
            'trialcard-poc.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'trialcard-test.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param authenticateUserRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async authenticationAuthenticateUser(authenticateUserRequestModel, xProgramId) {
        const _url_ = '/edge/authentication/AuthenticateUser';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'authenticateUserRequestModel' is not null or undefined
        if (authenticateUserRequestModel === null || authenticateUserRequestModel === undefined) {
            throw new Error('Required parameter authenticateUserRequestModel was null or undefined when calling authenticationAuthenticateUser.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(authenticateUserRequestModel, "AuthenticateUserRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationAuthenticateUserDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param changePasswordRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async authenticationChangePassword(changePasswordRequestModel, xProgramId) {
        const _url_ = '/edge/authentication/ChangePassword';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'changePasswordRequestModel' is not null or undefined
        if (changePasswordRequestModel === null || changePasswordRequestModel === undefined) {
            throw new Error('Required parameter changePasswordRequestModel was null or undefined when calling authenticationChangePassword.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(changePasswordRequestModel, "ChangePasswordRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationChangePasswordDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param body default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async authenticationGetCurrentUser(body, xProgramId) {
        const _url_ = '/edge/authentication/GetCurrentUser';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'body' is not null or undefined
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling authenticationGetCurrentUser.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(body, "object"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationGetCurrentUserDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param isEmailRegisteredRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async authenticationIsEmailRegistered(isEmailRegisteredRequestModel, xProgramId) {
        const _url_ = '/edge/authentication/IsEmailRegistered';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'isEmailRegisteredRequestModel' is not null or undefined
        if (isEmailRegisteredRequestModel === null || isEmailRegisteredRequestModel === undefined) {
            throw new Error('Required parameter isEmailRegisteredRequestModel was null or undefined when calling authenticationIsEmailRegistered.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(isEmailRegisteredRequestModel, "IsEmailRegisteredRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationIsEmailRegisteredDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param resetPasswordRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async authenticationResetPassword(resetPasswordRequestModel, xProgramId) {
        const _url_ = '/edge/authentication/ResetPassword';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'resetPasswordRequestModel' is not null or undefined
        if (resetPasswordRequestModel === null || resetPasswordRequestModel === undefined) {
            throw new Error('Required parameter resetPasswordRequestModel was null or undefined when calling authenticationResetPassword.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(resetPasswordRequestModel, "ResetPasswordRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationResetPasswordDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param scriptsAuthenticationSaveCurrentUserSaveCurrentUserRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async authenticationSaveCurrentUser(scriptsAuthenticationSaveCurrentUserSaveCurrentUserRequestModel, xProgramId) {
        const _url_ = '/edge/authentication/SaveCurrentUser';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'scriptsAuthenticationSaveCurrentUserSaveCurrentUserRequestModel' is not null or undefined
        if (scriptsAuthenticationSaveCurrentUserSaveCurrentUserRequestModel === null || scriptsAuthenticationSaveCurrentUserSaveCurrentUserRequestModel === undefined) {
            throw new Error('Required parameter scriptsAuthenticationSaveCurrentUserSaveCurrentUserRequestModel was null or undefined when calling authenticationSaveCurrentUser.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(scriptsAuthenticationSaveCurrentUserSaveCurrentUserRequestModel, "ScriptsAuthenticationSaveCurrentUserSaveCurrentUserRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationSaveCurrentUserDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param userAccountEmail
     * @param xProgramId The program id from the list of allowed program ids
     */
    async userAccountExists(userAccountEmail, xProgramId) {
        const _url_ = '/edge/authentication/v2/User/accountExists/{userAccountEmail}'
            .replace('{' + 'userAccountEmail' + '}', encodeURIComponent(String(userAccountEmail)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'userAccountEmail' is not null or undefined
        if (userAccountEmail === null || userAccountEmail === undefined) {
            throw new Error('Required parameter userAccountEmail was null or undefined when calling userAccountExists.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserAccountExistsUserAccountEmailAccountExistsResponse");
        }
        return response;
    }
    /**
     *
     * @param userRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async userCreatePortalAdmin(userRequestModel, xProgramId) {
        const _url_ = '/edge/authentication/v2/User/createPortalAdmin';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'userRequestModel' is not null or undefined
        if (userRequestModel === null || userRequestModel === undefined) {
            throw new Error('Required parameter userRequestModel was null or undefined when calling userCreatePortalAdmin.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(userRequestModel, "UserRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserCreatePortalAdminCreatePortalAdminResponse");
        }
        return response;
    }
    /**
     *
     * @param userRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async userCreateStandardUser(userRequestModel, xProgramId) {
        const _url_ = '/edge/authentication/v2/User/createStandardUser';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'userRequestModel' is not null or undefined
        if (userRequestModel === null || userRequestModel === undefined) {
            throw new Error('Required parameter userRequestModel was null or undefined when calling userCreateStandardUser.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(userRequestModel, "UserRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserCreateStandardUserCreateStandardUserResponse");
        }
        return response;
    }
    /**
     *
     * @param id
     * @param xProgramId The program id from the list of allowed program ids
     */
    async userDeleteUser(id, xProgramId) {
        const _url_ = '/edge/authentication/v2/User/deleteUser/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling userDeleteUser.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'DELETE',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserDeleteUserIdDeleteUserResponse");
        }
        return response;
    }
    /**
     *
     * @param id
     * @param xProgramId The program id from the list of allowed program ids
     */
    async userGetUserbyAuth0Id(id, xProgramId) {
        const _url_ = '/edge/authentication/v2/User/getUserbyAuth0Id/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling userGetUserbyAuth0Id.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserGetUserbyAuth0IdIdGetUserbyAuth0IdResponse");
        }
        return response;
    }
    /**
     *
     * @param linkedAccountId
     * @param xProgramId The program id from the list of allowed program ids
     */
    async userGetUsersByLinkedAccount(linkedAccountId, xProgramId) {
        const _url_ = '/edge/authentication/v2/User/getUsersByLinkedAccount/{linkedAccountId}'
            .replace('{' + 'linkedAccountId' + '}', encodeURIComponent(String(linkedAccountId)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'linkedAccountId' is not null or undefined
        if (linkedAccountId === null || linkedAccountId === undefined) {
            throw new Error('Required parameter linkedAccountId was null or undefined when calling userGetUsersByLinkedAccount.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserGetUsersByLinkedAccountLinkedAccountIdGetUsersByLinkedAccountResponse");
        }
        return response;
    }
    /**
     *
     * @param initialResetPasswordRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async userInitiatePasswordReset(initialResetPasswordRequestModel, xProgramId) {
        const _url_ = '/edge/authentication/v2/User/initiatePasswordReset';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'initialResetPasswordRequestModel' is not null or undefined
        if (initialResetPasswordRequestModel === null || initialResetPasswordRequestModel === undefined) {
            throw new Error('Required parameter initialResetPasswordRequestModel was null or undefined when calling userInitiatePasswordReset.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(initialResetPasswordRequestModel, "InitialResetPasswordRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserInitiatePasswordResetInitiatePasswordResetResponse");
        }
        return response;
    }
    /**
     *
     * @param id
     * @param userRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async userUpdateUser(id, userRequestModel, xProgramId) {
        const _url_ = '/edge/authentication/v2/User/updateUser/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling userUpdateUser.');
        }
        // verify required parameter 'userRequestModel' is not null or undefined
        if (userRequestModel === null || userRequestModel === undefined) {
            throw new Error('Required parameter userRequestModel was null or undefined when calling userUpdateUser.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(userRequestModel, "UserRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "AuthenticationV2UserUpdateUserIdUpdateUserResponse");
        }
        return response;
    }
};
EdgeAuthenticationApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgeAuthenticationApi);
export { EdgeAuthenticationApi };
//# sourceMappingURL=edgeAuthenticationApi.js.map